import { render, staticRenderFns } from "./WatsonDialog.vue?vue&type=template&id=5b8b7a74&scoped=true&"
import script from "./WatsonDialog.vue?vue&type=script&lang=js&"
export * from "./WatsonDialog.vue?vue&type=script&lang=js&"
import style0 from "./WatsonDialog.vue?vue&type=style&index=0&id=5b8b7a74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b7a74",
  null
  
)

export default component.exports